import React from 'react';

// Styles & Assets
import styles from './TablePatientUI.module.css';

// Hooks
import { useState } from 'react';

// Interfaces
import { ITablePatient } from '../../../interfaces/misc';
interface Props {
    tablePatient: ITablePatient
}

const TablePatientUI: React.FC<Props> = ({ tablePatient }) => {

    const [showRows, setShowRows] = useState<boolean>(true);

    const handleClickFirstRow = () => setShowRows(show => !show);
    const hiddenRow = !showRows ? styles.hiddenRow : '';

    return (
        <table className={styles.table}>
            <thead className={styles.inlineTable}>
                <tr onClick={handleClickFirstRow} className={`${styles.row} ${styles.firstRowHeader}`}>
                    <th className={`${styles.rowTitle} ${styles.firstColSticky}`}>{tablePatient.tableName}</th>
                    {tablePatient.headerRows[0]?.columns?.map(r => <th key={r.key}></th>)}
                </tr>
                {tablePatient.headerRows.map(r =>
                    <tr className={`${styles.row} ${styles.secondRowHeader} ${hiddenRow}`} key={r.key}>
                        <th className={styles.firstColSticky}>
                            {r.name}
                        </th>
                        {r.columns.map(hRow =>
                            <th key={hRow.key} className={styles.headerGlobalValue}>
                                {hRow.value}
                            </th>
                        )}
                    </tr>
                )}
            </thead>
            <tbody className={styles.inlineTable}>
                {tablePatient.bodyRows.map(bRow =>
                    <tr className={`${styles.row} ${hiddenRow}`} key={bRow.key}>
                        <td className={`${styles.rowTitle} ${styles.firstColSticky} ${styles.bgWhite}`}>
                            {bRow.name}
                        </td>
                        {bRow.columns.map(column => column)}
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TablePatientUI;